import { intersectionViewportObserver } from '@Foundation/utilities/intersectionViewportObserver';

export const animate = {
  name: 'animate',

  inserted(el, binding) {
    const {
      cssClass = 'animate',
      delay = 700,
      reset = false,
      threshold = [0.4]
    } = binding.value;

    setTimeout(() => {
      intersectionViewportObserver(el, {
        delay,
        checkIsVisible: true,
        threshold
      }).then(() => {
        !document.getElementsByTagName('body')[0].classList.contains('no-animation') && el.classList.add(cssClass);

        /*istanbul ignore else */
        if (reset) {
          setTimeout(() => {
            el.classList.add('animated');
            el.classList.remove(cssClass);
          }, 1500);
        }
      });
    }, 500);
  }
};
